module.exports = __webpack_public_path__ + "img/georgievsk_routes.c9815f05.jpg";